import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import { Container,Row, Col } from 'react-bootstrap';

function Main() {
    return(
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Registrar"/>
            <section className="project-detail">
                <div className='container'>
                <div className="row">
                            
                            <div className="col-lg-10 col-md-12 col-sm-12">
                                <h3 className = "c-heading">Sumit Kumar Biswas</h3>
                                <p><b>Shri Sumit Kumar Biswas</b> is currently the Registrar of the Indian Institute of Technology (IIT) Tirupati, Andhra Pradesh. He is on deputation from the Indian Institute of Technology Kharagpur, West Bengal.<br/>
                                <br/>
                                 He obtained his Master of Business Administration degree in 1992 from Burdwan University, West Bengal. He is a resourceful Chief Administrative Officer with 31+ years of administrative experience, out of which 24+ years have been at the Indian Institute of Technology, Kharagpur. He has an extensive experience with administrative management strategies.<br/>
                                 <br/>
                                 Initially joined the administrative service under the Government of West Bengal in February 1992. Thereafter, joined the Indian Institute of Technology Kharagpur in August 1999. He was an active member of several committees at IIT Kharagpur and contributed to determining, formulating and shaping policies in the overall direction of the Institute. Spearheaded the development of a new Medical College and a new Hospital as the Administrative-in-Charge, which is a new concept in the entire IIT System in India. Has profound knowledge of Disciplinary Proceedings as he was an active member of several Disciplinary Committee.<br/>
                                 <br/>
                                 Considering his overall contribution to the administration, he was conferred with the Staff Excellence Award (in the Group A Officer category, the highest level of recognition for officer-level administrative staff) in 2016, which was introduced for the first time in IIT Kharagpur.
                                 </p>
                            </div>

                            <div className="col-lg-2 col-md-12 col-sm-12">
                                <div className="team-img-box">
                                    <Link to="/registrar">
                                        <img src="https://files.iittp.ac.in/images/demo/iit/registrar.jpg" alt="img" />
                                    </Link>
                                    <h4 className ="c-heading">Registrar</h4>
                                </div>
                            </div>

                            
                        </div>
                    
                </div>
            </section>
        </>
    );
}

export default Main;